import {BZG_MODAL_DATA, BzgModalRef} from 'bz-genome-angular';
import {Component, Inject} from '@angular/core';


@Component({
  selector: 'pendingChangesEventLogAlert',
  templateUrl: './pending-changes-confirmation.component.html'
})
export class PendingChangesConfirmationComponent  {
  constructor(public modalComponentRef: BzgModalRef, @Inject(BZG_MODAL_DATA) public data: {message: string, title: string}) { }

  close() {
    this.modalComponentRef.close();
  }
  save() {
    this.modalComponentRef.close('save');
  }
}
